import { type AxiosInstance } from 'axios'
import { Cached } from '@coris-ts/helpers/utilities'
import { ModerationDataSource } from './data/moderation.data-source'
import { type SSEOptions } from '../../shared/primitives/createSSE'
import { GetInboxMessagesInteractor } from './domain/interactors/get-inbox-messages.interactor'
import { GetReviewedMessagesInteractor } from './domain/interactors/get-reviewed-messages.interactor'
import { ApplyActionInteractor } from './domain/interactors/apply-action.interactor'
import { GetFlaggingRulesInteractor } from './domain/interactors/get-flagging-rules.interactor'

export interface ModerationComponent {
  provideGetInboxMessages: () => GetInboxMessagesInteractor
  provideGetReviewedMessages: () => GetReviewedMessagesInteractor
  provideApplyAction: () => ApplyActionInteractor
  provideGetFlaggingRules: () => GetFlaggingRulesInteractor
  getSSEOptions: (onMessage: () => void) => Promise<SSEOptions>
}

export class ModerationDefaultModule implements ModerationComponent {
  constructor(
    private readonly baseUrl: string,
    private readonly axios: AxiosInstance,
    private readonly getOrganizationSlug: () => string | undefined
  ) {}

  @Cached()
  private getDataSource(): ModerationDataSource {
    return new ModerationDataSource(this.baseUrl, this.axios, this.getOrganizationSlug)
  }

  public provideGetInboxMessages(): GetInboxMessagesInteractor {
    return new GetInboxMessagesInteractor(this.getDataSource())
  }

  public provideGetReviewedMessages(): GetReviewedMessagesInteractor {
    return new GetReviewedMessagesInteractor(this.getDataSource())
  }

  public provideApplyAction(): ApplyActionInteractor {
    return new ApplyActionInteractor(this.getDataSource())
  }

  public provideGetFlaggingRules(): GetFlaggingRulesInteractor {
    return new GetFlaggingRulesInteractor(this.getDataSource())
  }

  public getSSEOptions(onMessage: () => void): Promise<SSEOptions> {
    return this.getDataSource().getSSEOptions(onMessage)
  }
}
